<template>
  <div>
    <h3 class="d-flex justify-start py-5">{{ $t('export_box.title_plural') }}</h3>
    <span class="d-flex justify-start align-center py-3">
      {{ $t('export.current_export_box') }}: {{ currentExportBoxName }}
      <v-chip color="error" v-if="currentExportBox"
        class="mx-3 d-flex align-center"
        outlined
        @click="selectExportBox(null)">
        {{ $t("common_actions.cancel_selection") }}
      </v-chip>
      <v-chip color="primary" v-if="currentExportBox"
        class="d-flex align-center"
        outlined
        @click="showExportBoxContent(currentExportBox)">
        {{ $t('export_box.show_content') }}
      </v-chip>
    </span>
    <v-data-table
      :loading="loading"
      :items="exportBoxesList"
      :headers="headers"
      :no-data-text="$t('table_settings.no_data')"
      :loading-text="$t('table_settings.loading_data')"
      :header-props="{
        sortByText: $t('table_settings.sort_by')
      }"
      :footer-props="{
        itemsPerPageAllText: $t('table_settings.all'),
        itemsPerPageOptions: [10, 25, 50, -1],
        itemsPerPageText: $t('table_settings.items_per_page')
        }">
      <template v-slot:[`item.export`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="createExportFromBox(item)">
          mdi-export
        </v-icon>
      </template>
      <template v-slot:[`item.selection`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="selectExportBox(item)">
          mdi-import
        </v-icon>
      </template>
      <template v-slot:[`item.content`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="showExportBoxContent(item)">
          mdi-archive-outline
        </v-icon>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="editItem(item)">
          mdi-pencil-outline
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)">
          mdi-delete-outline
        </v-icon>
      </template>
    </v-data-table>
    <export-box-edit :initExportBox="editedItem"
        :show-dialog="this.showDialog"
        @onSave="onSaveSuccess"
        @onCancel="onSaveCancel">
    </export-box-edit>
    <div class="mx-10">
      <v-col class="text-right">
        <v-btn fab small color="primary" @click="addItem" absolute>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </div>
    <v-snackbar v-model="showNoContentToExportSnackbar" color="error">
      {{ $t('export_box.no_content_to_export') }}
    </v-snackbar>
    <v-snackbar v-model="showDeleteErrorSnackbar" color="error">
      {{ $t('common_error.could_not_delete_item') }}
    </v-snackbar>
    <v-snackbar v-model="showLoadingErrorSnackbar" color="error">
      {{ $t('common_error.could_not_load_items')}}
    </v-snackbar>
    <confirm-dialog :show-dialog="this.showConfirmDeleteDialog"
      confirm-color="error"
      :question-text="this.confirmDeleteDialogText"
      :positive-text="$t('common_actions.delete')"
      :negative-text="$t('common_actions.cancel')"
      @onCancel="cancelDeleteItem"
      @onConfirm="confirmDeleteItem">
    </confirm-dialog>
    <v-snackbar v-model="showSelectedBoxDialog" color="success">
      {{ $t('export_box.selected_box') }}: {{ currentExportBox ? currentExportBox.name : '' }}
    </v-snackbar>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ExportBoxEdit from '@/components/exports/ExportBoxEdit'
import ConfirmDialog from '@/components/common/ConfirmDialog'

export default {
  components: { ExportBoxEdit, ConfirmDialog },
  name: 'ExportBoxes',
  data: () => ({
    loading: false,
    showNoContentToExportSnackbar: false,
    showConfirmDeleteDialog: false,
    confirmDeleteDialogText: '',
    showDialog: false,
    showDeleteErrorSnackbar: false,
    showLoadingErrorSnackbar: false,
    showSelectedBoxDialog: false,
    editedItem: {
      id: 0,
      index: -1,
      name: '',
      code: ''
    },
    headers: [
      {
        text: i18n.t('export_box.name'),
        value: 'name',
        align: 'start',
        sortable: true
      },
      {
        text: i18n.t('export_box.content_count'),
        value: 'contentCount',
        align: 'end'
      },
      {
        text: i18n.t('table_settings.export'),
        align: 'end',
        value: 'export',
        sortable: false,
        width: 100
      },
      {
        text: i18n.t('table_settings.selection'),
        align: 'end',
        value: 'selection',
        sortable: false,
        width: 100
      },
      {
        text: i18n.t('table_settings.content'),
        align: 'end',
        value: 'content',
        sortable: false,
        width: 100
      },
      {
        text: i18n.t('table_settings.edit'),
        align: 'end',
        value: 'edit',
        sortable: false,
        width: 100
      }
    ]
  }),
  computed: {
    exportBoxesList () {
      return this.$store.state.exportBoxes.exportBoxesList
    },
    currentExportBox () {
      return this.$store.state.exportBoxes.currentExportBox
    },
    currentExportBoxName () {
      var expBox = this.$store.state.exportBoxes.currentExportBox
      if (expBox == null) {
        return 'žádná krabice'
      }
      return expBox.name
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('exportBoxes/refreshExportBoxes').then(result => {
      this.loading = false
    }, _ => {
      this.loading = false
      this.showLoadingErrorSnackbar = true
    })
  },
  methods: {
    selectExportBox (item) {
      this.$store.dispatch('exportBoxes/setCurrentExportBox', item)
      if (item == null) {
        this.showSelectedBoxDialog = false
        return
      }
      this.showSelectedBoxDialog = true
    },
    createExportFromBox (item) {
      if (item.contentCount === 0) {
        this.showNoContentToExportSnackbar = true
        return
      }
      this.$router.push({ name: 'ExportCreate', params: { exportBox: item } })
    },
    showExportBoxContent (item) {
      if (item.contentCount === 0) {
        this.showNoContentToExportSnackbar = true
        return
      }
      this.$router.push({ name: 'ExportBoxContent', params: { exportBox: item } })
    },
    cancelDeleteItem () {
      this.showConfirmDeleteDialog = false
    },
    confirmDeleteItem () {
      this.showConfirmDeleteDialog = false
      this.loading = true
      this.$store.dispatch('exportBoxes/deleteExportBox', this.editedItem).then(result => {
        this.loading = false
      }, _ => {
        this.loading = false
        this.showDeleteErrorSnackbar = true
      })
    },
    editItem (item) {
      this.editedItem.id = item.id
      this.editedItem.name = item.name
      this.editedItem.code = item.code
      this.editedItem.index = this.exportBoxesList.indexOf(item)
      this.showDialog = true
    },
    deleteItem (item) {
      if (this.loading) {
        return
      }
      this.editedItem.id = item.id
      this.editedItem.name = item.name
      this.editedItem.index = this.exportBoxesList.indexOf(item)
      this.confirmDeleteDialogText = i18n.t('common_actions.confirm_delete') + ' Položka: ' + this.editedItem.name
      this.showConfirmDeleteDialog = true
    },
    addItem () {
      this.editedItem.id = 0
      this.editedItem.index = -1
      this.editedItem.name = ''
      this.editedItem.code = ''
      this.showDialog = true
    },
    onSaveSuccess () {
      this.showDialog = false
    },
    onSaveCancel () {
      this.showDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exports/ExportBoxes.vue